import { render } from "./SurveyQuestionsCharts.vue?vue&type=template&id=4bbc2f5e"
import script from "./SurveyQuestionsCharts.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionsCharts.vue?vue&type=script&lang=js"

import exportComponent from "F:\\omar pos 2\\pos_administration_platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__